export const init_inventario_location = "/inventario";
export const url_inventario_dashboard = `${init_inventario_location}/dashboard`;
export const url_inventario_inputs = `${init_inventario_location}/inputs`;
export const url_inventario_outputs = `${init_inventario_location}/outputs`;
export const url_inventario_stock = `${init_inventario_location}/stock`;
export const url_inventario_tools = `${init_inventario_location}/tools`;
